module.exports = __webpack_public_path__ + "static/logo-6cd37d8a6d0e73e4a5970c54f9f9e1a9.png";